import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../../../utils/api';

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [isLoading, setIsloading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    const getEvaluationsPATById = async () => {
      try {
        const result = await api.getPATEvaluationsReceivedById({ id });
        setData(result || []);
      } catch (error) {
        console.error('Failed to fetch PAT data:', error);
      } finally {
        setIsloading(false);
      }
    };

    getEvaluationsPATById();
  }, [id]);

  if (isLoading) {
    return (
      <div className='d-flex justify-content-center align-items-center py-5'>
        <div
          className='spinner-border text-primary'
          role='status'
        >
          <span className='visually-hidden'>Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className='container-fluid p-0 pb-5'>
      {/* Premium Header */}
      <div className='card border-0 rounded-4 mb-4 overflow-hidden shadow-sm'>
        <div className='card-body p-4'>
          <div className='d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3'>
            <div className='d-flex align-items-center gap-3'>
              <button
                onClick={() => navigate(-1)}
                className='btn btn-light rounded-circle d-flex align-items-center justify-content-center border transition-all hover-scale'
                style={{ width: '40px', height: '40px' }}
              >
                <i className='bi bi-arrow-left'></i>
              </button>
              <div>
                <span className='badge bg-info bg-opacity-10 text-info px-3 py-1 rounded-pill fw-bold small mb-1'>
                  Peer Assessment (360°)
                </span>
                <h1 className='h4 fw-bold mb-0 text-dark'>
                  Penilaian Antar Teman
                </h1>
              </div>
            </div>
            {data?.length > 0 && (
              <div className='d-flex align-items-center gap-2'>
                <span className='text-muted small'>Total Penilai:</span>
                <span className='badge bg-primary rounded-pill px-3'>
                  {data.length} Orang
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className='row g-4'>
        {data?.length < 1 ? (
          <div className='col-12'>
            <div className='card border-0 rounded-4 shadow-sm text-center py-5'>
              <div className='card-body'>
                <div
                  className='bg-warning bg-opacity-10 d-inline-flex align-items-center justify-content-center rounded-circle mb-3'
                  style={{ width: '80px', height: '80px' }}
                >
                  <i className='bi bi-people text-warning fs-1'></i>
                </div>
                <h5 className='fw-bold text-dark'>Belum Ada Penilaian</h5>
                <p className='text-muted'>
                  Teman sedivisi belum memberikan evaluasi untuk mahasiswa ini.
                </p>
                <button
                  onClick={() => navigate(-1)}
                  className='btn btn-outline-primary rounded-pill px-4 fw-bold mt-2'
                >
                  Kembali
                </button>
              </div>
            </div>
          </div>
        ) : (
          data.map((friend, key) => (
            <div
              key={key}
              className='col-12 col-xl-6'
            >
              <div className='card border-0 rounded-4 shadow-sm h-100 overflow-hidden transition-all'>
                {/* Friend Header */}
                <div className='card-header bg-white border-bottom p-4 d-flex justify-content-between align-items-center'>
                  <div className='d-flex align-items-center gap-3'>
                    <div
                      className='bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center fw-bold'
                      style={{ width: '45px', height: '45px' }}
                    >
                      {friend?.firstName?.charAt(0)}
                      {friend?.lastName?.charAt(0)}
                    </div>
                    <div>
                      <h6 className='fw-bold text-dark mb-0'>
                        {friend?.firstName} {friend?.lastName}
                      </h6>
                      <small className='text-muted'>Teman Se-divisi</small>
                    </div>
                  </div>
                  <button
                    onClick={() =>
                      navigate(`/mentor/mentees/${friend.friendsId}/evaluations`)
                    }
                    className='btn btn-light btn-sm rounded-pill fw-bold px-3 border shadow-xs transition-all hover-scale'
                  >
                    Profil <i className='bi bi-chevron-right ms-1 small'></i>
                  </button>
                </div>

                <div className='card-body p-4'>
                  {/* Scores Summary */}
                  <div className='row g-3 mb-4'>
                    <div className='col-6'>
                      <div className='p-3 rounded-4 bg-light text-center border border-light-subtle'>
                        <label className='small text-muted d-block mb-1'>
                          Rata-rata
                        </label>
                        <span className='h5 fw-bold text-primary mb-0'>
                          {friend?.average || 0}
                        </span>
                      </div>
                    </div>
                    <div className='col-6'>
                      <div className='p-3 rounded-4 bg-primary bg-opacity-10 text-center border border-primary border-opacity-10'>
                        <label className='small text-primary d-block mb-1 opacity-75'>
                          Total
                        </label>
                        <span className='h5 fw-bold text-primary mb-0'>
                          {friend?.total || 0}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Feedback Note */}
                  <div className='mb-4'>
                    <label className='small fw-bold text-dark mb-2 d-flex align-items-center gap-2'>
                      <i className='bi bi-chat-quote-fill text-info'></i>{' '}
                      Catatan Evaluasi
                    </label>
                    <div className='p-3 rounded-3 bg-light border-start border-4 border-info italic text-muted small'>
                      {friend?.note
                        ? `"${friend.note}"`
                        : 'Tidak ada catatan tambahan.'}
                    </div>
                  </div>

                  {/* Metrics Table */}
                  <div>
                    <label className='small fw-bold text-dark mb-2'>
                      Metrik Penilaian
                    </label>
                    <div className='table-responsive border rounded-3 overflow-hidden'>
                      <table className='table table-sm table-hover align-middle mb-0'>
                        <thead className='bg-light text-muted small fw-bold'>
                          <tr>
                            <th className='ps-3 py-2'>Klasifikasi</th>
                            <th className='text-end pe-3 py-2'>Nilai</th>
                          </tr>
                        </thead>
                        <tbody className='border-0'>
                          {friend?.evaluatedByFriends?.map((value, vKey) => (
                            <tr key={vKey}>
                              <td className='ps-3 py-2 small fw-medium text-dark'>
                                {value?.classification}
                              </td>
                              <td className='text-end pe-3 py-2 fw-bold text-primary'>
                                {value?.evaluation}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <style>{`
        .hover-scale:hover { transform: scale(1.05); }
        .transition-all { transition: all 0.2s ease; }
        .shadow-xs { box-shadow: 0 1px 2px rgba(0,0,0,0.05); }
      `}</style>
    </div>
  );
};

export default Detail;
